<div *ngIf="checkResponse">
    <img [src]="checkTrue" alt="checkTrue">
</div>

<div *ngIf="!checkResponse">
    <img [src]="checkFalse" alt="checkFalse">
</div>
